import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip} from "@mui/material";
import {dateToString} from "../../../Utils/dateUtils";
import {Check, Close, Delete, Edit, RemoveRedEye} from "@mui/icons-material";
import {EDIT, PENDING, VIEW} from "../../../Utils/constants";
import * as React from "react";

const EventEmailGrid = (props) => {
    const {emails, handleEmailSelection, handleDeleteGroupEmail} = props;

    return (
        <TableContainer>
            <Table aria-label="event group emails">
                <TableHead>
                    <TableRow>
                        <TableCell><b>Scheduled Time</b></TableCell>
                        <TableCell><b>Ready</b></TableCell>
                        <TableCell><b>Subject</b></TableCell>
                        <TableCell><b>Sender</b></TableCell>
                        <TableCell><b>Status</b></TableCell>
                        <TableCell><b>Action</b></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        emails?.map((email, index) => (
                            <TableRow key={index}>
                                <TableCell  width="150px">{email.scheduled_time ? dateToString(new Date(email.scheduled_time), 'dd/MM/yyyy HH:mm') : 'Not scheduled'}</TableCell>
                                <TableCell>{email.is_content_ready ? <Check color="success"/> : <Close color="error"/>}</TableCell>
                                <TableCell>
                                    <Tooltip title={<div
                                        dangerouslySetInnerHTML={{ __html: email.content }} ></div>}>
                                        <span>{email.subject}</span>
                                    </Tooltip>
                                </TableCell>
                                <TableCell>{`${email.sender.user_firstname} ${email.sender.user_lastname}`}</TableCell>
                                <TableCell>{email.status}</TableCell>
                                <TableCell width="110px">
                                    {
                                        email.status === PENDING && (
                                            <>
                                                <Tooltip title="Edit send-out">
                                                    <Edit color="primary" onClick={() => handleEmailSelection(email, EDIT)}/>
                                                </Tooltip>
                                                <Tooltip title={"Delete send-out"}>
                                                    <Delete color="error" onClick={() => handleDeleteGroupEmail(email)}/>
                                                </Tooltip>
                                            </>
                                        )
                                    }
                                    {
                                        email.status !== PENDING &&
                                        <Tooltip title={"View send-out"}>
                                            <RemoveRedEye color="primary"
                                                          onClick={() => {handleEmailSelection(email, VIEW);}}
                                            />
                                        </Tooltip>
                                    }
                                </TableCell>
                            </TableRow>
                        ))
                    }
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default EventEmailGrid;